import { ObjectType } from '../objects/types.js';
// Workstation types - determines which recipes are available
export const WorkstationType = {
    CRAFTING_TABLE: 'crafting_table',
    ANVIL: 'anvil',
    FURNACE: 'furnace',
    CAMPFIRE: 'campfire',
    COOKING_STOVE: 'cooking_stove',
};
// Mapping from ObjectType to WorkstationType
export const OBJECT_TO_WORKSTATION = {
    [ObjectType.CRAFTING_TABLE]: WorkstationType.CRAFTING_TABLE,
    [ObjectType.ANVIL]: WorkstationType.ANVIL,
    [ObjectType.FURNACE]: WorkstationType.FURNACE,
    [ObjectType.CAMPFIRE]: WorkstationType.CAMPFIRE,
    [ObjectType.COOKING_STOVE]: WorkstationType.COOKING_STOVE,
};
// Reverse mapping: WorkstationType to ObjectType
export const WORKSTATION_TO_OBJECT = {
    [WorkstationType.CRAFTING_TABLE]: ObjectType.CRAFTING_TABLE,
    [WorkstationType.ANVIL]: ObjectType.ANVIL,
    [WorkstationType.FURNACE]: ObjectType.FURNACE,
    [WorkstationType.CAMPFIRE]: ObjectType.CAMPFIRE,
    [WorkstationType.COOKING_STOVE]: ObjectType.COOKING_STOVE,
};
// Workstation display names
export const WORKSTATION_NAMES = {
    [WorkstationType.CRAFTING_TABLE]: 'Crafting Table',
    [WorkstationType.ANVIL]: 'Anvil',
    [WorkstationType.FURNACE]: 'Furnace',
    [WorkstationType.CAMPFIRE]: 'Campfire',
    [WorkstationType.COOKING_STOVE]: 'Cooking Stove',
};
// Get workstation type from object type
export const getWorkstationTypeFromObject = ({ objectType, }) => {
    return OBJECT_TO_WORKSTATION[objectType] ?? null;
};
// Get workstation display name
export const getWorkstationName = ({ workstationType, }) => {
    return WORKSTATION_NAMES[workstationType];
};
// Check if an object type is a workstation
export const isWorkstation = ({ objectType }) => {
    return OBJECT_TO_WORKSTATION[objectType] !== undefined;
};
//# sourceMappingURL=types.js.map